import { compose, isNil, not, path, pathEq } from 'ramda'

export const isFtaoAdministrator = pathEq(['frecUser', 'ftaoRole', 'code'], 'admin')
export const isFtaoContributor = pathEq(['frecUser', 'ftaoRole', 'code'], 'contributor')
export const isFtaoViewer = pathEq(['frecUser', 'ftaoRole', 'code'], 'viewer')

export const isFtaoUser = compose(not, isNil, path(['frecUser', 'ftaoRoleId']))
